<script setup lang="ts">
import { useLandingScroll } from '../composables/useLandingScroll'
import WlIcon from './WlIcon.vue'

const { registerReveal } = useLandingScroll()
</script>

<template>
  <section class="wl-cta-section">
    <div class="wl-cta-blob wl-cta-b1"></div>
    <div class="wl-cta-blob wl-cta-b2"></div>

    <div class="container">
      <div class="wl-cta-inner">
        <div class="wl-cta-text reveal" :ref="registerReveal">
          <h2>¿Listo para aprobar<br /><span class="gradient-text-light">tu próximo examen?</span></h2>
          <p>
            Únete a más de 5,000 estudiantes que ya confían en AppMisionate para alcanzar sus metas académicas.
            Acceso inmediato, sin instalaciones.
          </p>
          <p class="wl-cta-note">
            <span class="wl-cta-note-item"><WlIcon name="check" /> Sin tarjeta de crédito</span>
            <span class="wl-cta-note-item"><WlIcon name="check" /> Sin instalación</span>
            <span class="wl-cta-note-item"><WlIcon name="check" /> Cancela cuando quieras</span>
          </p>
        </div>

        <div class="wl-cta-visual reveal reveal-d1" :ref="registerReveal">
          <div class="wl-cta-card">
            <div class="wl-cta-score-circle">
              <span>92<small>%</small></span>
            </div>
            <p class="wl-cta-card-msg">¡Excelente resultado!</p>
            <div class="wl-cta-badge-row">
              <span class="wl-cta-chip"><WlIcon name="focus-target" /> Examen de ingreso</span>
              <span class="wl-cta-chip"><WlIcon name="check-circle" /> Aprobado</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
